import { Badge } from 'antd';
import { useEffectivePrototypeEnabled } from './prototypeMode';

type PrototypeBadgeProps = {
  className?: string;
  description?: string;
  label?: string;
};

export function PrototypeBadge({
  className,
  description,
  label = 'Prototype',
}: PrototypeBadgeProps) {
  const enabled = useEffectivePrototypeEnabled();

  if (!enabled) {
    return null;
  }

  const ariaLabel = description ? `${label}: ${description}` : label;

  return (
    <span aria-label={ariaLabel} className={className} title={description}>
      <Badge count={label} color="#9a3412" />
    </span>
  );
}
